import LazyImage from "../common/LazyImage";
import factory from "../../images/about/factory.jpg";
import aboutFactory from "../../images/about/about_card_image.jpg";
import gridImg1 from "../../images/about/grid-card-image1.jpg";
import gridImg2 from "../../images/about/grid-card-image2.jpg";
import bannerImage from "../../images/about/factory1.jpg";

const About = () => {
  return (
    <div className="about">
      <div className="main w-100 flex-column">
        <div className="head page-width flex-column gap-7x">
          <div className="info">
            <h2>
              Основанная в Италии в 1990 году международная компания AQUASTRONG
              специализируется на{" "}
              <span>
                разработке, производстве и продаже современных насосных решений,{" "}
              </span>{" "}
              охватывающих широкий спектр применения.
            </h2>
            <p className="text-m">
              За 30 лет на рынке бренд зарекомендовал себя профессионалом в
              сфере инноваций, надежности и передовых технологий насосного
              оборудования. Продукция компании успешно используется в системах
              водоснабжения, водоочистки, водоотведения и циркуляции – от
              компактных бытовых задач до сложных коммерческих и промышленных
              проектов.
            </p>
          </div>
          <LazyImage
            src={factory}
            alt="factory"
            className="factory-image"
            maxHeight="500px"
          />
        </div>

        <div className="geography w-100">
          <div className="page-width flex-column column-start gap-8x">
            <h1>AQUASTRONG в России</h1>
            <div className="info">
              <p>
                С 2022 года компания AQUASTRONG появилась на российском рынке,
                начав тесное сотрудничество с компанией «Водокомфорт».
                Это обеспечивает постоянное наличие продукции и
                квалифицированную поддержку на всех этапах – от выбора до
                сервисного обслуживания.
              </p>
            </div>
          </div>
        </div>

        <div className="cards flex-column gap-grid page-width ">
          <div className="cards-line w-100">
            <div className="card-item flex-column" id="card1">
              <div className="head w-100 flex-row flex-between">
                <h3>01</h3>
                <h3>Производство и стандарты качества</h3>
              </div>
              <p className="text-m">
                Одним из ключевых шагов в истории Aquastrong стало
                стратегическое сотрудничество с китайской компанией LEO PUMP в
                2005 году, что позволило существенно расширить производственные
                мощности и усилить своё присутствие на международной арене. На
                данный момент AQUASTRONG располагает четырьмя производственными
                площадками в Китае и одним заводом в Турции. Это партнерство и
                собственные инновационные разработки гарантируют доступ к
                передовым технологиям и позволяют предлагать по-настоящему
                широкий ассортимент высокотехнологичных решений, соответствующий
                самым высоким стандартам качества.
              </p>
            </div>
            <div className="card-item flex-column card-accent" id="card2">
              <div className="head w-100 flex-row flex-between">
                <h3>02</h3>
                <h3>История и глобальное присутствие</h3>
              </div>
              <p className="text-m">
                Наш многолетний международный опыт, накопленный на рынках Южной
                Европы, Ближнего Востока и стран СНГ, позволяет понимать
                потребности клиентов и предлагать наиболее эффективные решения.
              </p>
            </div>
          </div>

          <div className="cards-line w-100">
            <div className="card-item flex-column" id="card3">
              <div className="head w-100 flex-row flex-between">
                <h3>03</h3>
                <h3>Инновации и научные разработки</h3>
              </div>
              <p className="text-m">
                Сила AQUASTRONG не только в опыте, но и в постоянном стремлении
                к совершенству через инновации. Одним из ключевых аспектов
                развития является непрерывное инвестирование в научные
                исследования и разработки. Ежегодно компания вкладывает более
                200 миллионов юаней в улучшение технологий, повышение
                эффективности и внедрение передовых решений в наше оборудование.
              </p>
            </div>
            <LazyImage
              src={aboutFactory}
              alt="factory"
              className="card-item flex-column card-image"
              maxWidth="800px"
              maxHeight="280px"
            />
          </div>
        </div>

        <div className="development gap-8x flex-column column-start page-width">
          <h1>Ключевые направления технологического развития</h1>

          <div className="info-row w-100">
            <h3>Интернет вещей (IoT)</h3>
            <p className="text-m">
              Интеграция датчиков и интеллектуальных систем мониторинга
              позволяет собирать данные работе в режиме реального времени.
              Это обеспечивает возможность удаленного контроля, предиктивной
              аналитики и своевременного обслуживания.
            </p>
          </div>

          <div className="info-row w-100">
            <h3>Облачные вычисления</h3>
            <p className="text-m">
              AQUASTRONG использует мощные облачные платформы для интеграции
              аналитических систем. Благодаря этому можно эффективно
              контролировать работу установленного оборудования, анализировать
              данные и оперативно настраивать рабочие параметры для максимальной
              производительности и энергоэффективности.
            </p>
          </div>

          <div className="info-row w-100">
            <h3>Цифровизация процессов</h3>
            <p className="text-m">
              Применение современных цифровых технологий и автоматизированного
              управления на всех этапах производства позволяет снизить
              себестоимость продукции и сократить сроки выполнения заказов,
              гарантируя неизменно высокое качество.
            </p>
          </div>
        </div>

        <LazyImage src={bannerImage} alt="factory" className="banner" />

        <div className="advantages page-width flex-column column-start gap-8x">
          <h1>Преимущества</h1>
          <div class="grid-container w-100">
            <div class="grid-item flex-column flex-between column-start">
              <h3 className="w-100">Инновационные решения</h3>
              <p className="w-100">
                Оборудование, созданное с применением передовых технологий IoT,
                облачных вычислений и цифровизации
              </p>
            </div>
            <div class="grid-item flex-column flex-between column-start">
              <h3 className="w-100 text-accent-default">
                Гарантированное качество
              </h3>
              <p className="w-100">
                Продукция создается на крупносерийном автоматизированном
                производстве, что обеспечивает стабильность и исключает ошибки
              </p>
            </div>
            <div class="grid-item image-container">
              <LazyImage src={gridImg1} alt="factory" className="grid-image" />
            </div>
            <div class="grid-item flex-column flex-between column-start">
              <h3 className="w-100">Широкий выбор</h3>
              <p className="w-100">
                Обширная продуктовая линейка позволяет подобрать решение
                практически для любой задачи
              </p>
            </div>
            <div class="grid-item flex-column logo-container">
              <LazyImage
                src="https://aquastrong.it/wp-content/uploads/2024/10/96d6f2e7e1f705a.webp"
                alt="aquastrong"
                className="logo-image"
                maxWidth="250px"
                maxHeight="105px"
              />
            </div>
            <div class="grid-item flex-column flex-between column-start">
              <h3 className="w-100">Долговечность</h3>
              <p className="w-100">
                Гарантия 2 года, а срок службы оборудования –не менее 10 лет
              </p>
            </div>
            <div class="grid-item image-container">
              <LazyImage src={gridImg2} alt="factory" className="grid-image" />
            </div>
            <div class="grid-item flex-column flex-between column-start">
              <h3 className="w-100">Наличие на складе</h3>
              <p className="w-100">
                Постоянный складской запас в России (более 8000 единиц)
                гарантирует быструю отгрузку
              </p>
            </div>
            <div class="grid-item  flex-column flex-between column-start">
              <h3 className="w-100 text-accent-default">
                Соответствие стандартам
              </h3>
              <p className="w-100">
                Вся продукция соответствует российским техническим регламентам,
                имеет гигиенические сертификаты и сертификаты сейсмостойкости,
                подтверждающие ее безопасность и надежность
              </p>
            </div>
          </div>
        </div>

        <div className="bottom page-width">
          <h1>
            <span>AQUASTRONG</span> – это больше, чем просто насосное
            оборудование. Это интеллектуальные и надежные решения для
            эффективного управления водными системами сегодня и в будущем,
            созданные с заботой о качестве и потребностях наших клиентов.
          </h1>
        </div>
      </div>
    </div>
  );
};

export default About;
